import { useCallback, useContext } from 'react'

import useThreeDModelUploader from 'Pods/ThreeDStudio/Shared/UploadThreeDModelButton/Hooks/useThreeDModelUploader'
import { openSignInModal, openThreeDModelPicker } from 'Pods/ThreeDStudio/Store/actions/ui'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

/**
 * Shared behaviour for every "bring your own 3D model" entry point - the header button,
 * the viewer empty-state button and the sidebar library card. Off the picker flag they
 * all open the OS file dialog exactly as before; on it they all open the picker, which
 * carries the same upload as its first tile.
 *
 * Consumers must render the returned hidden input unconditionally: modelPickerEnabled
 * arrives client-side on this fast page, so gating the input's existence on it would make
 * the server markup disagree with the first client render and break hydration.
 */
export default function useThreeDModelEntryPoint() {
  const { modelPickerEnabled, userLoggedIn } = useContext(ThreeDStudioPageContext)
  const { acceptedExtensions, inputRef, isLoading, onFileChange, onFileClick } = useThreeDModelUploader()

  const handleClick = useCallback(() => {
    if (!modelPickerEnabled) {
      onFileClick()
      return
    }
    if (!userLoggedIn) {
      openSignInModal('signup')
      return
    }
    openThreeDModelPicker()
  }, [modelPickerEnabled, userLoggedIn, onFileClick])

  return {
    acceptedExtensions,
    inputRef,
    isLoading,
    onFileChange,
    onClick: handleClick,
  }
}
